import { useMutation, useQuery } from "@tanstack/react-query";
import { Formik, useFormikContext } from "formik";
import React from "react";
import { getNotifications, updateNotifications } from "src/api/settings";
import { Button } from "src/components/ui/button";
import { Switch } from "src/components/ui/switch";
import { NOTIFICATIONS_SETTINGS } from "src/lib/constants";
import { showSuccessToast } from "src/lib/utils";

const Notifications = () => {
	const { data, refetch } = useQuery({
		queryKey: ["notification-settings"],
		queryFn: getNotifications,
		suspense: true,
	});
	const { mutate, isLoading } = useMutation(updateNotifications, {
		onSuccess: ({ message }) => {
			showSuccessToast(message);
			refetch();
		},
	});

	const initialValues = data?.data;

	return (
		<div className="tw-grid tw-justify-center">
			<Formik initialValues={initialValues} onSubmit={(values) => mutate(values)}>
				{({ values, dirty, handleSubmit }) => (
					<form onSubmit={handleSubmit} className="settings_cont_ins tw-px-8 tw-grid tw-gap-12 tw-max-w-[600px]">
						{Object.entries(NOTIFICATIONS_SETTINGS).map(([key, settings]) => (
							<NotificationGroup key={key} settings={settings} name={key}>
								{settings.map((setting, index) => (
									<Notification key={index} setting={setting} value={values[setting.value]} />
								))}
							</NotificationGroup>
						))}
						<Button disabled={!dirty || isLoading}>Save updates</Button>
					</form>
				)}
			</Formik>
		</div>
	);
};

const NotificationGroup = ({ name, children }) => {
	return (
		<div>
			<p className="tw-mb-3 tw-text-green tw-font-semibold tw-uppercase tw-text-lg">{name}</p>
			{children}
		</div>
	);
};

const Notification = ({ setting, value }) => {
	const { setFieldValue } = useFormikContext();

	return (
		<div className="tw-mb-1.5 tw-flex tw-justify-between tw-items-center tw-gap-10">
			<div>
				<p className="tw-text-[#3A3A3A] tw-capitalize tw-font-semibold text-[14px]">{setting.name.split("_").join(" ")}</p>
				<span className="tw-text-[#333333] tw-text-[13px]">{setting.description}</span>
			</div>
			<Switch checked={value} onCheckedChange={(value) => setFieldValue(setting.value, value)} />
		</div>
	);
};

export default Notifications;
